<template>
  <v-btn
    depressed
    small
    text
    class="wklr-icon-btn"
    :class="sizeClass"
    @click="$emit('click', $event)"
    @mouseenter="$emit('mouseenter', $event)"
    @mouseleave="$emit('mouseleave', $event)"
    ><wklr-icon left class="icon" :class="rotateClass" :type="$props.type" :size="iconSize" />
    <span class="text">
      <slot />
    </span>
  </v-btn>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'nuxt-property-decorator';
import WklrIcon from '@/components/shared/wklr-icon.vue';
import { IconTypes, BtnSize } from '@/components/shared/types';

/**
 * アイコンを利用したボタンを表示する
 *
 * ## サイズ
 *
 * 種類|ボタンサイズ|アイコンサイズ
 * ---|---|---
 * normal | 40x40 | 24x24
 * small | 24x24 | 16x16
 * dense | 24x24 | 20x20
 */
@Component({ components: { WklrIcon } })
export default class WklrIconBtn extends Vue {
  /** アイコンの種類 */
  @Prop() type!: IconTypes;
  /** ボタンのサイズ */
  @Prop({ default: 'normal' }) size!: BtnSize;
  /** type が chevron の場合アイコンの向きを指定できる */
  @Prop({ default: 'right' }) direction!: 'right' | 'down' | 'left' | 'up';

  get sizeClass(): string {
    switch (this.size) {
      case 'small':
        return '-small';
      case 'normal':
        return '';
    }
  }

  get iconSize(): string {
    switch (this.size) {
      case 'small':
        return 'x-small';
      case 'normal':
        return 'normal';
    }
  }

  get rotateClass(): string {
    if (this.type !== 'chevron') return '';
    return `-rotate-${this.direction}`;
  }
}
</script>

<style lang="scss" scoped>
.wklr-icon-btn {
  color: #8f8f8f;
  padding: 0 4px !important;
  min-width: 0 !important;
  display: inline-block; // ホバー時にずれるのを防ぐ

  &:hover {
    color: $primary;
  }

  ::v-deep .v-btn__content {
    align-items: center;
    justify-content: center;
  }

  .icon {
    line-height: 20px;

    &.-rotate-right {
      transform: rotate(0deg);
    }
    &.-rotate-down {
      transform: rotate(90deg);
    }
    &.-rotate-left {
      transform: rotate(180deg);
    }
    &.-rotate-up {
      transform: rotate(-90deg);
    }
  }

  .text {
    display: inline-block;
    font-size: 0.9rem;
  }

  ::v-deep {
    .v-btn__content .v-icon--left {
      margin: 1px 4px 0 0;
      width: 24px;
      height: 24px;
    }
  }

  &.-small {
    .text {
      font-size: 0.8rem;
    }

    ::v-deep {
      .v-btn__content .v-icon--left {
        margin: 1px 4px 0 0;
        width: 18px;
        height: 18px;
      }
    }
  }
}
</style>
